import { ValoresOpcaoPagamentoDto } from '@/models/dto/DetalheOfertaDto';

export default class ValoresOpcaoPagamentoResource {
  valorDesconto: number;
  percentualDesconto: number;
  valorTotal?: number | null;

  constructor(dto: ValoresOpcaoPagamentoDto) {
    this.valorDesconto = dto.valorDesconto;
    this.percentualDesconto = dto.percentualDesconto;
    this.valorTotal = dto.valorTotal;
  }
}
